module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header-4ea8a7f1fc329fccf855739dcf74442a.jpg";